// Customers List Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get CustomerList from backend then update CustomerList in vuex store ***** //
export const updateCustomersList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('customers_index', { params: params })
    commit('updateCustomersList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch Customer from backend ***** //
export const fetchCustomerInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`customers_show/${payload}`)
    commit('fetchCustomerInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Customer ***** //
export const addCustomer = async (ignored, payload = null) => {
  try {
    await Axios.post('customers_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Customer info ***** //
export const updateCustomerInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`customers_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete customer ***** //
export const deleteCustomer = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`customers_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

export const setFullCustomersList = async ({ commit }) => {
  let customersList = []

  try {
    const result = await Axios.get('customers_list')
    result.data.data.forEach(customer => {
      customersList.push({
        value: customer.customer_id,
        text: customer.customer_name
      })
    })
    commit('setFullCustomersList', customersList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

export const setSaleCustomersList = async ({ commit }) => {
  let customersList = []

  try {
    const result = await Axios.get('sale_customers_list')
    result.data.data.forEach(customer => {
      customersList.push({
        value: customer.customer_id,
        text: customer.customer_name
      })
    })
    commit('setSaleCustomersList', customersList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
